import { _s } from '@/locale';

const baseKey = 'components.app.EmbedBlocked';

const EmbedBlocked = () => (
  <div className="flex min-h-[240px] flex-col items-center justify-center px-6 text-center">
    <p className="text-fg_primary">{_s(`${baseKey}.message`, { defaultValue: 'This page is not available here.' })}</p>
    <button type="button" className="mt-4 underline" onClick={() => window.history.back()}>
      {_s(`${baseKey}.back`, { defaultValue: 'Go back' })}
    </button>
  </div>
);

export default EmbedBlocked;
